import { useNavigate } from "react-router-dom";
import { TarjetaCompacta } from "../../shared";

// Tarjeta compacta de un paso asignado al administrador, con el mismo aspecto
// que las de destacados. Al clickearla abre la actividad.
export default function TarjetaPaso({ paso }) {
  const navigate = useNavigate();

  function abrir(event) {
    if (event.metaKey || event.ctrlKey) {
      window.open(paso.link, "_blank");
    } else {
      navigate(paso.link);
    }
  }

  return (
    <TarjetaCompacta
      icono="pi pi-list-check"
      etiqueta={paso.actividad}
      titulo={paso.paso}
      lineas={[[paso.proceso, paso.cliente].filter(Boolean).join(" · ")]}
      onClick={abrir}
    />
  );
}
